module.exports = __webpack_public_path__ + "resources/img/img-tmax-hyper-sql-for-postgre-sql-01-m-en.ba4bb0cc45475b26bed3e8da95d8a94a.png";